import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import Button from "../common/Button";
import useTendering from "../../hooks/useTendering";
import AppContext from "../../AppContext";

const NDA = ({ tenderingId, onClose }) => {
  const [signed, setSigned] = useState(true);
  const { user } = useContext(AppContext);
  const { getById, signNDA } = useTendering();

  useEffect(() => {
    getById(tenderingId).then((data) => {
      // * Check if NDA is signed
      const participation = data.participants.find((p) => p.user === user._id);
      if (participation.nda.signed) {
        return;
      }

      setSigned(false);
    });
  }, [tenderingId]);

  const handleSignClick = async () => {
    await signNDA(tenderingId, user._id);
    onClose();
  };

  return (
    <Overlay
      onClose={onClose}
      content={
        <div className="tendering-nda">
          <h3>NDA</h3>
          <div className="tendering-nda__container">
            <span className="tendering-nda__container__text">
              A non-disclosure agreement (NDA) is a legally binding contract
              between you and another party (or parties) in which one party
              agrees to maintain the confidentiality of information the other
              party shares. In other words, an NDA to prevents sensitive
              information from falling into the wrong hands. An NDA also defines
              what information is considered private and describes the terms of
              the confidential relationship. If you're the recipient of this
              sensitive information, known as the receiving party, you're bound
              by the terms of the NDA and may only use the information for the
              purpose outlined in the agreement. You might use non-disclosure
              agreements in business relationships, employment contracts, and
              during the sale or licensing of intellectual property.
            </span>
          </div>
          {!signed && (
            <div className="tendering-nda__footer">
              <Button
                label={"Disagree"}
                variant={"secondary"}
                size={"small"}
                onClick={onClose}
              />
              <Button
                label={"Agree"}
                size={"small"}
                onClick={handleSignClick}
              />
            </div>
          )}
        </div>
      }
    />
  );
};

NDA.propTypes = {};

export default NDA;
